// Configurações centralizadas da aplicação

interface CompanyConfig {
  name: string;
  shortName: string;
  phone: string;
  phoneFormatted: string;
  instagram: string;
  instagramUrl: string;
  businessHours: string;
  location: string;
  region: string;
  colors: {
    orange: string;
    dark: string;
  };
}

export const COMPANY: CompanyConfig = {
  name: 'SD Serviços e Manutenções',
  shortName: 'SD Serviços',
  phone: '5549991725327', // Formato sem formatação para WhatsApp
  phoneFormatted: '(49) 99172-5327', // Formato para exibição
  instagram: '@sd.servicosemanutencoes',
  instagramUrl: 'https://instagram.com/sd.servicosemanutencoes',
  businessHours: 'Segunda a Sábado: 8h às 18h',
  location: 'Xanxerê',
  region: 'Meio Oeste de Santa Catarina',
  colors: {
    orange: '#FF6B1A',
    dark: '#1a1a1a',
  }
};

export default COMPANY;
